export default "__VITE_ASSET__aa6ba851__"